/***
 * Created on 2023/7/12
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import ReactDom from "react-dom";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import {getErrorMessage} from 'common/ServiceCommon';


const ModalDialog = forwardRef(function ModalDialog(props, ref) {
    const {title, closeModal, showModal, children, submitText, cancelText, submitAction, withWizardMode=false, withStepBar=false, stepContent, ...rest_props} = props;
    const dom = document.querySelector('body .modal-dialog');
    const submitButtonRef = useRef();
    const { t } = useTranslation();
    const [alertProp, setAlertProp] = useState({type: '', show: false, message: ''});
    const [hideCancel, setHideCancel] = useState(!!rest_props?.hideCancel);
    const [submitTitle, setSubmitTitle] = useState(submitText);
    const [customSubmit, setCustomSubmit] = useState(null);

    let onSubmit = async () => {
        submitButtonRef.current.disabled = true;
        if (typeof submitAction === 'function') {
            try {
                await submitAction();
            } catch (error) {
                submitButtonRef.current.disabled = false;
                if (![1019016].includes(error?.cause?.code)) {
                    setAlertProp({type: 'error', show: true, message: getErrorMessage(t, error.cause?.code)});
                }
            } finally {
                // submitButtonRef.current.disabled = false;
            }
        }
    }

    useImperativeHandle(ref, () => {
        return {
            disableSubmitButton: (value) => {
                submitButtonRef.current.disabled = value;
            },
            alert: (type, show, message) => {
                setAlertProp(prev => ({type, show, message}));
            },
            toggleCancelButton: (value) => {
                setHideCancel(!value);
            },
            updateSubmitText: (value) => {
                setSubmitTitle(value);
            },
            setSubmitAction: (callback) => {
                setCustomSubmit(async () => {
                    await callback()
                })
            }
        }
    });

    useEffect(() => {
        if (rest_props?.initDisableSubmit) {
            submitButtonRef.current.disabled = true;
        }
    }, [submitButtonRef?.current]);

    const modal = (
        <div className="comp-dialog-wrapper" >
            <div className="comp-dialog" data-modal-dialog>
                { alertProp?.show &&
                    <div className="comp-dialog-alert">
                        <div
                            className={`alert-content alert-content--${alertProp.type} ${alertProp.show ? 'show-alert' : ''}`}>
                            <div className="alert-content__text">{alertProp.message}</div>
                            <div className="alert-content__btn-close cursor-pointer"
                                 onClick={() => setAlertProp(prev => ({...prev, show: false}))}></div>
                        </div>
                    </div>
                }

                <div className="dialog-header">
                    <div className="dialog-header__title">{title || ""}</div>
                    {
                        !hideCancel && <div className="dialog-header__btn-close cursor-pointer" data-close-dialog onClick={closeModal} />
                    }
                </div>

                {
                    withStepBar &&
                    <ul className="dialog-step-bar">
                        {stepContent()}
                    </ul>
                }

                <div className="dialog-body">
                    {children}
                </div>
                <div className="dialog-footer">
                    {
                        !withWizardMode &&
                        <div className="q-btn-group btn-align-right">
                            {
                                !rest_props?.hideSubmit && <button className="q-btn q-btn--primary" onClick={async (e)=> await onSubmit(e)} ref={submitButtonRef}>{submitTitle || t("@OK@")}</button>
                            }
                            {
                                !hideCancel && <button className="q-btn q-btn--default" onClick={closeModal}>{cancelText || t("@Cancel@")}</button>
                            }
                        </div>
                    }
                    {
                        withWizardMode &&
                        <div className="dialog-footer__wizard-mode">
                            <div className="q-btn-group mr-auto">
                                { !hideCancel && <button className="q-btn q-btn--default" onClick={closeModal}>{t('@Cancel@')}</button> }
                            </div>
                            <div className="q-btn-group ml-auto">
                                {!rest_props.hideSubmit && <button className="q-btn q-btn--primary" onClick={async (e)=> customSubmit ? await customSubmit(e) : await onSubmit(e)} ref={submitButtonRef}>{submitTitle || t('@Next@')}</button>}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );

    return ReactDom.createPortal(
        props.showModal && modal
    , dom);
});

export default ModalDialog;